var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourismOfficeWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2388 17.8309H15C15.5523 17.8309 16 18.2786 16 18.8309V19.9992C16 20.5514 15.5524 20.9991 15.0001 20.9992L9.00012 20.9999C8.44779 20.9999 8 20.5522 8 19.9999V18.8309C8 18.2786 8.44772 17.8309 9 17.8309H9.78673L9.78575 11.1449H9.6344C8.72825 11.1449 8.02459 10.433 8.02459 9.57328C8.02459 8.68863 8.75382 8.00165 9.6344 8.00165H13.2389C13.7911 8.00165 14.2389 8.44937 14.2389 9.00166L14.2388 17.8309ZM11.7484 6.30606C13.258 6.30606 14.4659 5.12685 14.4659 3.65303C14.4659 2.17921 13.2581 1 11.7484 1C10.2388 1 9.03094 2.17921 9.03094 3.65303C9.03094 5.12685 10.2388 6.30606 11.7484 6.30606Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourismOfficeWhite);
export default __webpack_public_path__ + "static/media/tourism-office-white.b869b4a300f8f5ff79805fd4a9165fa3.svg";
export { ForwardRef as ReactComponent };